import React from 'react';

export function Footer() {
  return (
    <footer className="bg-[#101828] border-t border-gray-700">
      <div className="max-w-7xl mx-auto py-8 px-4 sm:px-6 lg:px-8">
        <div className="text-center text-sm text-gray-300">
          © 2025 Zeswitch SAS. All rights reserved.
        </div>
      </div>
    </footer>
  );
}